import { ActionType } from "../../actions/actionTypes";

const INITIAL_STATE = {};

export default (
  state: UserInfo = INITIAL_STATE,
  action: ActionType
): UserInfo => {
  switch (action.type) {
    case "FETCH_USER_INFOS_SUCCESS": {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};
